import { AxiosHeaders, AxiosResponse, InternalAxiosRequestConfig } from 'axios';

import { AccessToken } from '../access-token';
import { HttpServiceConfigurator } from '../http-service/http-service-configurator';

export class SSOHttpServiceConfigurator extends HttpServiceConfigurator {
  baseUrl: string;

  constructor(baseUrl: string) {
    super();
    this.baseUrl = baseUrl;
  }

  getHttpClientConfig() {
    const baseConfig = super.getHttpClientConfig();
    return {
      ...baseConfig,
      baseURL: this.baseUrl,
      headers: new AxiosHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' }),
    };
  }

  async prepareRequestConfig(
    baseConfig: InternalAxiosRequestConfig
  ): Promise<InternalAxiosRequestConfig> {

    return {
      ...baseConfig,
      data: new URLSearchParams(baseConfig.data),
    };
  }
  prepareHttpSuccessResponse(response: AxiosResponse) {
    AccessToken.setTokenFromHttpResponse(response);
    return response;
  }

  prepareHttpErrorResponse(error: any) {
    return Promise.reject(error);
  }
}
